import { render } from "./testVue.vue?vue&type=template&id=5a75dae1"
import script from "./testVue.vue?vue&type=script&lang=js"
export * from "./testVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__